export const Preguntas = [
    {
        pregunta: "¿Quién puede ser un mentor voluntario?",
        respuesta: [
            {
                title: "Profesionistas con el siguiente perfil",
                body: "<ul><li>Contar con estudios de nivel licenciatura o posgrado.</li><li>Contar con un empleo formal con antigüedad de al menos 2 años.</li><li>En caso de no ser colaborador o docente de Tecmilenio, su empresa deberá tener convenio de socio formador y autorización de su jefe inmediato o RH para participar</li></ul>"
            },
            {
                title: "Estudiantes con el siguiente perfil",
                body: "<ul><li>Haber estudiado por lo menos un año en Tecmilenio.</li><li>Encontrarse inscrito.</li><li>Contar con un promedio mínimo de 80.</li><li>No contar con sanciones disciplinarias.</li><li>Contar con la autorización de su líder de acompañamiento (líder de generación, mentor, coordinador, asesor o coach).</li></ul>"
            }
        ],
        id: "1"
    },
    {
        pregunta: "¿Cómo es que los estudiantes saben que soy un mentor voluntario?",
        respuesta: [
            {
                body: "Los estudiantes cuentan con un buscador de mentores voluntarios por categoría y días de disponibilidad. Esto significa que cuando realicen una búsqueda, podrán identificarte y podrán solicitarte una sesión de mentoría."
            }
        ],
        id: "2"
    },
    {
        pregunta: "¿Qué categorías de ayuda existen en el programa?",
        respuesta: [
            {
                title: "Las categorías de ayuda se relacionan principalmente con:",
                body: "<ul><li>Mentoría general: propósito de vida, finanzas personales, administración del tiempo, rendimiento académico, entre otras.</li><li>Mentoría por área de conocimiento: ingeniería, negocios, tecnología, salud, entre otras.</li><li>Vivencia en Tecmilenio: actividades en campus, sociedades, grupos estudiantiles, unboxing, entre otras.</li></ul>"
            }
        ],
        id: "3"
    },
    {
        pregunta: "¿Cuántas horas debo invertir en el programa?",
        respuesta: [
            {
                body: "Tu podrás decidir cuántas horas invertir en este programa de voluntariado. Cuando un estudiante solicite tu apoyo, tu podrás aceptar o declinar la solicitud en función de tu disponibilidad."
            }
        ],
        id: "4"
    },
    {
        pregunta: "¿A cuántos alumnos puedo atender de manera simultánea?",
        respuesta: [
            {
                body: "Tu podrás decidir cuántas relaciones de mentoría puedes tener de manera simultánea. Cuando un estudiante solicite tu apoyo, tu podrás aceptar o declinar la solicitud en función de tu disponibilidad."
            }
        ],
        id: "5"
    },
    {
        pregunta: "¿Cuál es la duración de una relación de mentoría?",
        respuesta: [
            {
                body: "Tu podrás definir junto con tu estudiante la duración de la relación. Existirán ciertas orientaciones que con una sola sesión sea suficiente, pero otras podrían requerir más sesiones para que el estudiante alcance el objetivo que se ha planteado."
            }
        ],
        id: "6"
    },
    {
        pregunta: "¿Cuándo se da por terminada una relación de mentoría?",
        respuesta: [
            {
                body: "Una vez que el estudiante ha alcanzado sus objetivos, o cuando de manera anticipada mentor o estudiante deciden dar por terminada la relación por motivos previstos en los términos y condiciones."
            }
        ],
        id: "7"
    },
    {
        pregunta: "¿Qué estudiantes pueden utilizar el servicio?",
        respuesta: [
            {
                body: "Cualquier estudiante activo de Universidad Tecmilenio puede utilizar el servicio."
            }
        ],
        id: "8"
    },
    {
        pregunta: "¿Existe alguna remuneración por participar en el programa?",
        respuesta: [
            {
                body: "No. Soy mentor es un programa de voluntariado."
            }
        ],
        id: "9"
    },
    {
        pregunta: "¿Existe alguna evaluación a mi labor como mentor voluntario?",
        respuesta: [
            {
                body: "Los estudiantes podrán evaluar cada sesión de mentoría y tu también podrás evaluar su desempeño."
            }
        ],
        id: "10"
    },
    {
        pregunta: "¿Las sesiones de mentoría son virtuales o presenciales?",
        respuesta: [
            {
                body: "Durante la contingencia por COVID-19, las sesiones de mentoría con los estudiantes son 100% virtuales. Una vez que se de el regreso a campus y se autorice por parte de la Vicerrectoría de Educación Experiencial el tener sesiones presenciales de mentoría voluntaria, tu podrás siempre decidir si la quieres hacer presencial o virtual."
            }
        ],
        id: "11"
    },
    {
        pregunta: "¿Existe alguna metodología para las sesiones de mentoría?",
        respuesta: [
            {
                body: "Sí, nosotros te proporcionamos los recursos para que puedas incrementar tus competencias para el desarrollo de una mentoría apreciativa."
            }
        ],
        id: "12"
    },
    {
        pregunta: "¿Cuál es la duración del programa?",
        respuesta: [
            {
                body: "La duración es indeterminada, tu podrás definir el tiempo que deseas ser parte de Soy Mentor. "
            }
        ],
        id: "13"
    },
    {
        pregunta: "¿Por qué tengo que escoger el campus más cercano?",
        respuesta: [
            {
                body: "El campus más cercano es para que el estudiante pueda identificarlo principalmente cuando busque realizar una sesión presencial. Recuerda que en todo momento será una decisión de ambos la definición del medio para realizar la sesión ya sea virtual o presencial."
            }
        ],
        id: "14"
    }
];

export const Paises = [
    {
        nombre: "México",
        id: 1
    },
    {
        nombre: "Estados Unidos",
        id: 2
    }
    ,
    {
        nombre: "Canadá",
        id: 3
    }
    ,
    {
        nombre: "",
        id: 4
    }
    ,
    {
        nombre: "",
        id: 5
    }
    ,
    {
        nombre: "",
        id: 6
    }
    ,
    {
        nombre: "",
        id: 7
    }
    ,
    {
        nombre: "",
        id: 8
    }
    ,
    {
        nombre: "",
        id: 9
    }
]